enum PodonexVersionChannelEnum {
    LATEST = 'latest',
    STABLE = 'stable',
    FIXED = 'fixed',
}

export default PodonexVersionChannelEnum;
